import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppBarTitleService, OfferCalculatorService} from 'common';
import { DomSanitizer } from '@angular/platform-browser';
import { AppSettings } from '../../../app.settings';
import { CurrencyPipe, PercentPipe } from '@angular/common';
import { ApplicationService } from '../application.service';
import { BaseCalculatorComponent } from '../../calculator/base/base-calculator.component';

@Component({
    selector: 'ifa-law-case-financing-content',
    templateUrl: './law-case-financing-content.component.html',
    styleUrls: ['./law-case-financing-content.component.scss'],
    standalone: false
})
export class LawCaseFinancingContentComponent extends BaseCalculatorComponent {
  constructor(
    route: ActivatedRoute,
    sanitizer: DomSanitizer,
    appBarTitleService: AppBarTitleService,
    calculatorService: OfferCalculatorService,
    applicationService: ApplicationService,
    settings: AppSettings,
    percentPipe: PercentPipe,
    currencyPipe: CurrencyPipe
  ) {
    super(route, sanitizer, appBarTitleService, calculatorService, applicationService, settings, percentPipe, currencyPipe);
  }

}
